import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { useBrand } from "@/context/SiteContext";

export default function Login() {
  const { login } = useAuth();
  const brand = useBrand();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  useSeo({ title: `Admin Login | ${brand.name}` });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md card-surface p-8">
        <div className="w-12 h-12 rounded-xl bg-emerald-500/15 flex items-center justify-center mb-4"><Lock className="text-emerald-400" size={22} /></div>
        <h1 className="font-display text-2xl font-bold text-white">Admin Portal</h1>
        <p className="text-slate-400 text-sm mt-1 mb-6">Sign in to manage leads and site configuration.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="lf" />
          <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="lf" />
          {err && <div className="text-red-400 text-sm" data-testid="login-error">{err}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit"><LogIn size={16} /> {loading ? "Signing in..." : "Sign In"}</button>
        </form>
      </div>
      <style>{`.lf{width:100%;background:#060B11;border:1px solid rgba(255,255,255,.1);border-radius:.6rem;padding:.8rem 1rem;color:#E2E8F0;font-size:.9rem;outline:none}.lf:focus{border-color:#10B981}`}</style>
    </div>
  );
}
